import { Link } from "react-router-dom";
import Seo from "@/components/feature/Seo";
import Breadcrumb from "@/components/feature/Breadcrumb";
import TipForm from "@/components/feature/TipForm";
import { testimonials } from "@/mocks/topics";

const principles = [
  {
    icon: "ri-shield-check-line",
    title: "先核实，再整理",
    text: "只整理已经在公开平台被大量讨论的话题，凡是没有明确回应的部分，都会在正文里标注为待确认。",
  },
  {
    icon: "ri-user-forbid-line",
    title: "不碰个人隐私",
    text: "涉及真实身份、住址、联系方式等隐私信息的内容一律不收录，人物与事件统一作虚构化处理。",
  },
  {
    icon: "ri-scales-3-line",
    title: "区分事实与讨论",
    text: "正文里会明确区分「已经发生的事」和「网友的猜测」，避免把讨论当成结论来传播。",
  },
  {
    icon: "ri-refresh-line",
    title: "持续更新与纠错",
    text: "话题有后续进展会补充到时间线，如果早期信息有误，我们会在原话题上标注更正说明。",
  },
];

const stages = [
  { value: "2h", label: "榜单刷新" },
  { value: "6", label: "内容分类" },
  { value: "128+", label: "每日话题整理" },
  { value: "100%", label: "虚构化处理" },
];

export default function About() {
  const schema = [
    {
      "@context": "https://schema.org",
      "@type": "AboutPage",
      name: "关于黑料瓜网",
      url: "https://duopingheyi.cn/about",
      description: "黑料瓜网的品牌介绍、网站定位、内容原则与联系方式。",
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "黑料瓜网",
      url: "https://duopingheyi.cn/",
      email: "heiliaogua@example.com",
      description: "娱乐热点资讯聚合平台，把分散的娱乐热议整理成榜单与速递。",
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "首页", item: "https://duopingheyi.cn/" },
        { "@type": "ListItem", position: 2, name: "关于我们", item: "https://duopingheyi.cn/about" },
      ],
    },
  ];

  return (
    <>
      <Seo
        title="关于我们 - 黑料瓜网品牌介绍与内容原则"
        description="了解黑料瓜网的品牌定位、内容原则与团队理念。我们只整理公开讨论的娱乐话题，人物事件均作虚构化处理，并持续更新与纠错。"
        keywords="关于黑料瓜网,品牌介绍,内容原则,娱乐资讯平台,吃瓜榜单"
        path="/about"
        schema={schema}
      />

      <section className="border-b border-background-200 bg-background-100">
        <div className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-8 md:py-14">
          <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "关于我们" }]} />
          <h1 className="mt-4 font-heading text-3xl font-black text-foreground-950 md:text-5xl">
            关于黑料瓜网
          </h1>
          <p className="mt-3 max-w-3xl text-sm leading-relaxed text-foreground-600 md:text-base">
            黑料瓜网是一个娱乐热点资讯聚合平台。我们不生产爆料，而是把分散在各处的公开讨论整理成榜单、时间线和分类，让吃瓜这件事变得更清楚、更省时间。
          </p>
        </div>
      </section>

      <section className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
          <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
            <span className="font-label text-xs font-bold tracking-[0.25em] text-primary-600">
              WHO WE ARE
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              我们是谁
            </h2>
            <div className="mt-4 flex flex-col gap-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              <p>
                黑料瓜网成立于两年前，最初只是几个爱看热闹的人做的一份「今天大家在聊什么」清单。随着关注的人越来越多，我们把它做成了固定的今日速递和吃瓜榜单。
              </p>
              <p>
                我们的读者大多是通勤路上刷手机、周末偶尔放松的普通网友。他们没时间同时盯好几个平台，只想知道一件事：现在到底在讨论什么，前因后果是什么。
              </p>
              <p>
                所以我们的重点从来不是「谁又塌房了」，而是把话题的背景、时间线和各方回应讲清楚，让每个人看完能自己判断。
              </p>
            </div>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
            <span className="font-label text-xs font-bold tracking-[0.25em] text-primary-600">
              POSITIONING
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              网站定位
            </h2>
            <div className="mt-4 flex flex-col gap-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              <p>
                我们把自己定位成「娱乐话题的整理者」，而不是「消息的源头」。所有内容都来自公开讨论，我们不首发、不独家、不做站队。
              </p>
              <p>
                排行只看讨论规模，不看立场。热度高不代表我们认可话题内容，热度低也不代表它不重要——榜单只是帮你快速定位当下最热的那几件事。
              </p>
              <p>
                未来我们会继续把分类做细，让追星、追剧、追综艺的人都能快速找到自己关心的那一栏。
              </p>
            </div>
          </div>
        </div>

        <dl className="mt-8 grid grid-cols-2 gap-4 lg:grid-cols-4">
          {stages.map((stage) => (
            <div
              key={stage.label}
              className="flex flex-col items-center justify-center rounded-lg border border-background-200 bg-accent-50 py-6"
            >
              <dt className="font-heading text-3xl font-black text-accent-700">{stage.value}</dt>
              <dd className="mt-1 font-label text-xs text-foreground-600">{stage.label}</dd>
            </div>
          ))}
        </dl>
      </section>

      <section id="principle" className="w-full border-y border-background-200 bg-background-100">
        <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-8 md:py-16">
          <div className="max-w-2xl">
            <span className="font-label text-xs font-bold tracking-[0.25em] text-primary-600">
              PRINCIPLES
            </span>
            <h2 className="mt-2 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
              内容原则
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              这四条是我们做每一条内容时都会遵守的底线，也是我们和纯标题党最大的区别。
            </p>
          </div>

          <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
            {principles.map((item) => (
              <article
                key={item.title}
                className="flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                  <i className={`${item.icon} h-5 w-5 flex items-center justify-center`}></i>
                </span>
                <div>
                  <h3 className="font-heading text-lg font-bold text-foreground-950">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.text}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-8 md:py-16">
        <div className="max-w-2xl">
          <span className="font-label text-xs font-bold tracking-[0.25em] text-primary-600">
            VOICES
          </span>
          <h2 className="mt-2 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
            读者怎么说
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            来自读者的真实反馈，是我们持续更新下去的动力。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
          {testimonials.map((item) => (
            <figure
              key={item.name}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <i className="ri-double-quotes-l h-6 w-6 flex items-center justify-center text-accent-500"></i>
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                {item.text}
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200 pt-4">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-100 font-heading text-sm font-bold text-secondary-800">
                  {item.name.slice(0, 1)}
                </span>
                <span className="flex flex-col">
                  <span className="font-label text-sm font-bold text-foreground-900">
                    {item.name}
                  </span>
                  <span className="font-label text-xs text-foreground-500">{item.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </section>

      <section id="contact" className="w-full border-t border-background-200 bg-background-100">
        <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-8 md:py-16">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
            <div className="lg:col-span-1">
              <span className="font-label text-xs font-bold tracking-[0.25em] text-primary-600">
                CONTACT
              </span>
              <h2 className="mt-2 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
                联系我们
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                想补充线索、反馈内容问题，或者聊合作，都可以通过下面的方式找到我们。
              </p>
              <ul className="mt-6 flex flex-col gap-3 text-sm text-foreground-700">
                <li className="flex items-center gap-2">
                  <i className="ri-mail-line h-4 w-4 flex items-center justify-center text-primary-600"></i>
                  heiliaogua@example.com
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-time-line h-4 w-4 flex items-center justify-center text-primary-600"></i>
                  工作日 10:00 - 18:00 处理反馈
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-chat-3-line h-4 w-4 flex items-center justify-center text-primary-600"></i>
                  一般 1 个工作日内回复
                </li>
              </ul>
              <Link
                to="/rank"
                className="mt-6 inline-flex items-center gap-1 rounded-md border border-background-300 bg-background-50 px-4 py-2 font-label text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
              >
                <i className="ri-list-check h-4 w-4 flex items-center justify-center"></i>
                先去逛逛榜单
              </Link>
            </div>
            <div className="lg:col-span-2">
              <TipForm />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}